// extracted by mini-css-extract-plugin
module.exports = {"countContainer":"styles_countContainer__fXQnh","widgetTitle":"styles_widgetTitle__1oN9F"};